import ApplicationController from "./application_controller"
import { validatePricing, parsePricingValue, formatPricing, calculateYear1Total, getCurrencySymbol } from '../utils/pricing'

export default class extends ApplicationController {
  static targets = ["nrc", "mrc", "year1Total", "monthlyAvg", "currency"]

  connect() {
    super.connect()
    this.calculate()
  }

  calculate() {
    const nrc = this.hasNrcTarget ? parsePricingValue(this.nrcTarget.value) : 0
    const mrc = this.hasMrcTarget ? parsePricingValue(this.mrcTarget.value) : 0
    const currency = this.getCurrency()

    const year1Total = calculateYear1Total(nrc, mrc)
    const monthlyAvg = year1Total / 12

    this.updateDisplay(year1Total, monthlyAvg, currency)
    this.highlightChanges()
  }

  getCurrency() {
    const currencyField = this.element.querySelector('[name*="currency"]')
    if (currencyField && currencyField.value.trim()) {
      return currencyField.value.trim().toUpperCase()
    }
    return 'USD'
  }

  updateDisplay(year1Total, monthlyAvg, currency) {
    const currencySymbol = getCurrencySymbol(currency)

    if (this.hasYear1TotalTarget) {
      this.year1TotalTarget.textContent = `${currencySymbol}${formatPricing(year1Total)}`
    }

    if (this.hasMonthlyAvgTarget) {
      this.monthlyAvgTarget.textContent = `${currencySymbol}${formatPricing(monthlyAvg)}`
    }

    if (this.hasCurrencyTarget) {
      this.currencyTarget.textContent = currency
    }
  }

  highlightChanges() {
    const summaryCard = this.element.querySelector('.price-summary-card')
    if (summaryCard) {
      summaryCard.classList.add('calculation-updated')
      setTimeout(() => {
        summaryCard.classList.remove('calculation-updated')
      }, 1000)
    }
  }

  validatePricing() {
    const nrc = this.hasNrcTarget ? parsePricingValue(this.nrcTarget.value) : 0
    const mrc = this.hasMrcTarget ? parsePricingValue(this.mrcTarget.value) : 0

    return validatePricing(nrc, mrc)
  }
}
